import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-alt pe-2" }, null, -1)
const _hoisted_4 = { class: "main_side" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tachometer-alt pe-2" }, null, -1)
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users pe-2" }, null, -1)
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list pe-2" }, null, -1)
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list pe-2" }, null, -1)
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list pe-2" }, null, -1)
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user pe-2" }, null, -1)
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-credit-card pe-2" }, null, -1)
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cogs pe-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-caret-down" }, null, -1)
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cogs pe-2" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-caret-down" }, null, -1)
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-percentage pe-2" }, null, -1)
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-percentage pe-2" }, null, -1)
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-archive pe-2" }, null, -1)
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-check pe-2" }, null, -1)
const _hoisted_39 = { class: "nav-item" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-alt pe-2" }, null, -1)
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-alt pe-2" }, null, -1)
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe-americas pe-2" }, null, -1)
const _hoisted_45 = { class: "nav-item" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-city pe-2" }, null, -1)
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cogs pe-2" }, null, -1)
const _hoisted_49 = { class: "nav-item" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-percentage pe-2" }, null, -1)
const _hoisted_51 = { class: "nav-item" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-percentage pe-2" }, null, -1)
const _hoisted_53 = { class: "nav-item" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cogs pe-2" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-caret-down" }, null, -1)
const _hoisted_56 = { class: "nav-item" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_58 = { class: "nav-item" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_60 = { class: "nav-item" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_62 = { class: "nav-item" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell pe-2" }, null, -1)
const _hoisted_66 = { class: "nav-item" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user pe-2" }, null, -1)
const _hoisted_68 = { class: "nav-item" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card pe-2" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt pe-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($props.isshowsidebar)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/profile",
            id: "profile",
            class: "p-2 text-white text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString($setup.name), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              "active-class": "active",
              id: "dashboard",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode(" Dashbaord")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/users",
              "active-class": "active",
              id: "users",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(" Users")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/orders",
              "active-class": "active",
              id: "orders",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Orders")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/bookings",
              "active-class": "active",
              id: "orders",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createTextVNode(" Bookings")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/orderscustomreport",
              "active-class": "active",
              id: "orderscustomer",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createTextVNode(" Orders Customer Report")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: "/drivers",
              "active-class": "active",
              id: "drivers",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createTextVNode("Drivers")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: "/withdrawrequest",
              "active-class": "active",
              id: "withdrawrequest",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _createTextVNode("Withdraw Requests")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              id: "reports",
              class: "nav-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.reportsetting && $setup.reportsetting(...args)))
            }, [
              _hoisted_20,
              _createTextVNode("Reports "),
              _hoisted_21
            ]),
            _createElementVNode("ul", {
              class: _normalizeClass($setup.toogle.showReport ? 'show': 'hide' )
            }, [
              _createElementVNode("li", _hoisted_22, [
                _createVNode(_component_router_link, {
                  to: "/adminreporthourly",
                  "active-class": "active",
                  id: "hourlyreport",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createTextVNode("Hourly Reports")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: "/adminreportdaily",
                  "active-class": "active",
                  id: "dailyreport",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _createTextVNode(" Daily Reports")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_26, [
                _createVNode(_component_router_link, {
                  to: "/adminreportmonthly",
                  "active-class": "active",
                  id: "monthlyreport",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _createTextVNode(" Montly Reports")
                  ]),
                  _: 1
                })
              ])
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_28, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              id: "setting",
              class: "nav-link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.sidebarsetting && $setup.sidebarsetting(...args)))
            }, [
              _hoisted_29,
              _createTextVNode("Settings "),
              _hoisted_30
            ]),
            _createElementVNode("ul", {
              class: _normalizeClass($setup.toogle.showSetting ? 'show': 'hide' )
            }, [
              _createElementVNode("li", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: "/rates",
                  "active-class": "active",
                  id: "ratelist",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createTextVNode(" Rate List")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_33, [
                _createVNode(_component_router_link, {
                  to: "/shifts",
                  "active-class": "active",
                  id: "shifts",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _createTextVNode("Shifts")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_35, [
                _createVNode(_component_router_link, {
                  to: "/packages",
                  "active-class": "active",
                  id: "package",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _createTextVNode("Packages")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_37, [
                _createVNode(_component_router_link, {
                  to: "/paymentmethods",
                  "active-class": "active",
                  id: "paymentmethod",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _createTextVNode(" Payment Methods")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_39, [
                _createVNode(_component_router_link, {
                  to: "/cms",
                  "active-class": "active",
                  id: "cmspages",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_40,
                    _createTextVNode("Cms Pages")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_41, [
                _createVNode(_component_router_link, {
                  to: "/roles",
                  "active-class": "active",
                  id: "rolelist",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_42,
                    _createTextVNode(" Role List")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_43, [
                _createVNode(_component_router_link, {
                  to: "/countries",
                  "active-class": "active",
                  id: "countrylist",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_44,
                    _createTextVNode(" Country List")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_45, [
                _createVNode(_component_router_link, {
                  to: "/cities",
                  "active-class": "active",
                  id: "citylist",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_46,
                    _createTextVNode(" City List")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_47, [
                _createVNode(_component_router_link, {
                  to: "/configurations",
                  "active-class": "active",
                  id: "configuration",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_48,
                    _createTextVNode(" Configurations")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_49, [
                _createVNode(_component_router_link, {
                  to: "/rateranges",
                  "active-class": "active",
                  id: "raterange",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_50,
                    _createTextVNode(" Rate Range List")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_51, [
                _createVNode(_component_router_link, {
                  to: "/forceupdate",
                  "active-class": "active",
                  id: "forceupdate",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_52,
                    _createTextVNode("Force Update List")
                  ]),
                  _: 1
                })
              ])
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_53, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              id: "logs",
              class: "nav-link",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.logsetting && $setup.logsetting(...args)))
            }, [
              _hoisted_54,
              _createTextVNode("Logs "),
              _hoisted_55
            ]),
            _createElementVNode("ul", {
              class: _normalizeClass($setup.toogle.showLog ? 'show': 'hide' )
            }, [
              _createElementVNode("li", _hoisted_56, [
                _createVNode(_component_router_link, {
                  to: "/orderpushs",
                  "active-class": "active",
                  id: "riderpushlog",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57,
                    _createTextVNode("Rider Order Push Log")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_58, [
                _createVNode(_component_router_link, {
                  to: "/drivers/loginlogs",
                  "active-class": "active",
                  id: "driverloginlog",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_59,
                    _createTextVNode("Driver login Logs ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_60, [
                _createVNode(_component_router_link, {
                  to: "/ordercancellists",
                  "active-class": "active",
                  id: "ordercancellog",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_61,
                    _createTextVNode("Order Cancel Log")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_62, [
                _createVNode(_component_router_link, {
                  to: "/smslog",
                  "active-class": "active",
                  id: "smslog",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_63,
                    _createTextVNode("SMS Log")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_64, [
                _createVNode(_component_router_link, {
                  to: "/notifications",
                  "active-class": "active",
                  id: "notificationlog",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_65,
                    _createTextVNode(" Notifications Log")
                  ]),
                  _: 1
                })
              ])
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_66, [
            _createVNode(_component_router_link, {
              to: "/devices",
              "active-class": "active",
              id: "deviceslist",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_67,
                _createTextVNode("Devices List")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_68, [
            _createVNode(_component_router_link, {
              to: "/addresses",
              "active-class": "active",
              id: "addresslist",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_69,
                _createTextVNode("Address List")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/login",
              onClick: $setup.logout,
              id: "logoutlink"
            }, {
              default: _withCtx(() => [
                _hoisted_70,
                _createTextVNode(" Sign out")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}